/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingIntroduceAutopilotStep_org = {
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly optimisticSavingsForCurrentUserNextWeekErrorable: ({
        readonly __typename: "OptimisticSavings";
        readonly couldCalculate: boolean;
        readonly savingMinutes: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "OnboardingIntroduceAutopilotStep_org";
};
export type OnboardingIntroduceAutopilotStep_org$data = OnboardingIntroduceAutopilotStep_org;
export type OnboardingIntroduceAutopilotStep_org$key = {
    readonly " $data"?: OnboardingIntroduceAutopilotStep_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingIntroduceAutopilotStep_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingIntroduceAutopilotStep_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "experiments",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "optimisticSavingsForCurrentUserNextWeekErrorable",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "couldCalculate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "savingMinutes",
                            "storageKey": null
                        }
                    ],
                    "type": "OptimisticSavings",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '5db0e84df37187f861573afe3446ca6e';
export default node;
